import * as fastXmlParser from 'fast-xml-parser';
import * as xmlbuilder2 from 'xmlbuilder2';

export {
  fastXmlParser,
  xmlbuilder2,
};
